export const getOnelinksOptions = (array) => {
  const onelinksOptions = [{ label: 'Не выбрано', value: 0 }];
  if (array) {
    array.map((item) => onelinksOptions.push({ value: item.ID, label: item.ID }));
  }

  return onelinksOptions;
};
